import React, { FC, Fragment, MouseEventHandler } from "react";
import { ButtonPrimary } from "../atoms/ButtonPrimary";
import { ButtonSecondary } from "../atoms/ButtonSecondary";
import { classNames } from "@/shared/utils/classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { Subscription } from "@/app/billing/subscription";

export type SubscriptionCardProps = {
  subscription: Subscription;
  onCancel: MouseEventHandler<HTMLButtonElement>;
};

export const SubscriptionCard: FC<SubscriptionCardProps> = ({
  subscription,
  onCancel,
}) => {
  return (
    <li className={classNames("px-4 py-4 sm:px-0 bg-white flex gap-4")}>
      <div className="flex">
        <img className="h-64 w-64" src={subscription?.plan?.image} />
      </div>
      <div className="flex flex-col flex-1 gap-2">
        <p className="text-primary font-bold text-xl">
          {subscription?.plan?.name}
        </p>
        <div>
          <p>{subscription?.plan?.description}</p>
        </div>
        <ul className="list-disc">
          {subscription?.plan?.features.map((feature) => (
            <li className="text-sm ml-4 text-gray-700">{feature}</li>
          ))}
        </ul>
        {subscription?.status === "active" && (
          <div className="justify-end flex">
            <div>
              <ButtonSecondary
                onClick={onCancel}
                text="Cancelar"
                size="large"
              />
            </div>
          </div>
        )}
      </div>
    </li>
  );
};
